import { styled } from '@cherre-frontend/ui';

export const ConnectorStageHeaderContainer = styled('div')<{
  backgroundColor: string;
}>`
  background-color: ${({ backgroundColor }) => backgroundColor};
  font-family: Montserrat;
  font-weight: 700;
  font-size: 12px;
  line-height: 17.5px;
  letter-spacing: 1%;
  vertical-align: middle;
  padding: 10px;
  width: 100%;
  display: flex;
  justify-content: center;
  color: #ffffff;
  position: sticky;
  top: 0px;
`;
